<template>
  <!-- A grid of the templates, each a small drawing and its name. One is chosen. -->
  <div role="radiogroup" aria-label="Template" class="grid gap-2" :class="columns">
    <button v-for="option in TEMPLATES" :key="option.id" type="button" role="radio" :aria-checked="modelValue === option.id" :title="`${option.blurb} ${option.hint}.`"
      @click="$emit('update:modelValue', option.id)"
      class="rounded-lg p-1.5 border text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/50"
      :class="modelValue === option.id ? 'border-blue-500 ring-2 ring-blue-500/30 bg-blue-50/50 dark:bg-blue-900/10' : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 bg-gray-50 dark:bg-[#161b22]'">
      <ResumeThumb :template="option.id" :accent="accent" />
      <span class="block text-[11px] font-semibold text-gray-800 dark:text-gray-100 text-center mt-1 leading-tight">{{ option.label }}</span>
      <span class="block text-[9px] text-gray-400 dark:text-gray-500 text-center leading-tight truncate">{{ option.hint }}</span>
    </button>
  </div>
</template>

<script setup>
import ResumeThumb from './ResumeThumb.vue'
import { TEMPLATES } from './templates.js'

defineProps({
  modelValue: { type: String, default: 'modern' },
  accent: { type: String, default: '#2563eb' },
  columns: { type: String, default: 'grid-cols-3' }, // a Tailwind grid-cols class
})
defineEmits(['update:modelValue'])
</script>
